import { useEffect } from 'react';
import {
  FcfsBookings,
  FcfsBookingsSearchParams,
} from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useFcfsBookings(params: FcfsBookingsSearchParams) {
  const reports = useAxios(
    (axios, signal, params: FcfsBookingsSearchParams) =>
      axios.request<FcfsBookings>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/fcfs/report`,
        method: 'GET',
        params,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    reports.execute(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return reports;
}

export type FcfsBookingsRequest = ReturnType<typeof useFcfsBookings>;
